export default "__VITE_ASSET__0a61a83e__"